import { defineModule, localActionContext, localGetterContext } from 'direct-vuex'

import { DIALOG_DEFAULT_WIDTH } from '@/constants/practiceConstants'

export interface DialogOptions {
  title: string
  message: string

  width?: number | string

  canReject?: boolean
  acceptText?: string
  acceptColor?: string
  onAccept?: () => unknown // may be async; the dialog awaits it
  isRejectable?: boolean
  rejectText?: string
  onReject?: () => void
}

const defaultOptions: DialogOptions = {
  acceptColor: 'primary',
  acceptText: 'Confirm',
  canReject: true,
  isRejectable: true,
  message: '',
  onAccept: () => {},
  onReject: () => {},
  rejectText: 'Cancel',
  title: '',
  width: DIALOG_DEFAULT_WIDTH,
}

export interface DialogState {
  visible: boolean
  options: DialogOptions
}

const resetState = (): DialogState => {
  return {
    options: { ...defaultOptions },
    visible: false,
  }
}

const dialog = defineModule({
  actions: {
    /** Close the dialog and run its onAccept handler. A failing handler is logged, never left as an unhandled rejection. */
    async accept(context) {
      const { commit, state } = dialogActionContext(context)
      commit.hide()
      try {
        await state.options.onAccept?.()
      } catch (error) {
        console.error('dialog onAccept failed:', error)
      }
    },

    hide(context) {
      const { commit } = dialogActionContext(context)
      commit.hide()
    },

    show(context, options: DialogOptions) {
      const { commit } = dialogActionContext(context)
      console.log('dialog actions show, payload =')
      console.log(options)
      commit.show(options)
    },
  },

  getters: {
    options(...args): DialogOptions {
      const { state } = dialogGetterContext(args)
      return state.options
    },

    visible(...args): boolean {
      const { state } = dialogGetterContext(args)
      return state.visible
    },
  },

  mutations: {
    hide(state: DialogState) {
      // DO NOT DO THIS
      // (because we're still going to call options.onAccept() after hide()-ing the window)
      // by setting it to {...defaultOptions} we'll blow away onAccept()
      // state.options = { ...defaultOptions }
      state.visible = false
    },

    show(state: DialogState, options: DialogOptions) {
      state.options = { ...defaultOptions, ...options }
      console.log('store dialog mutations show, state.options =')
      console.log(state.options)
      state.visible = true
    },
  },

  namespaced: true as const,

  state: resetState(),
})

export default dialog
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dialogGetterContext = (args: [any, any, any, any]) => localGetterContext(args, dialog)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dialogActionContext = (context: any) => localActionContext(context, dialog)
